import { createContext } from "react";

export const CollectionContext = createContext(null);

export default function CollectionProvider({
    collection,
    children,
}) {
    return (
        <CollectionContext.Provider value={collection}>
            {children}
        </CollectionContext.Provider>
    );
}